export default {
	namespaced: true,
	state: {
		title: '',
	},
	mutations: {
		setTitle(state, value) {
			state.title = value
		}
	},
	actions: {
	}
}